<template>
  <PageContentLayoutOnly role="region">
    <div v-if="paymentsEnabled === true">
      <div>
        <b-notification type="is-info is-light" has-icon aria-close-label="Close notification">
          Automatic Payments allow you to set up your Homeowners Assessment payments to
          automatically debit from your credit card or bank account when they are due. These charges
          are typically applied around the 7th or 8th of the month that the assessment is applied.
          To enable Automatic Payments, select a Payment Method from the list below. If you do not
          have any Payment Methods listed, please go to the Payment Methods tab and add your payment
          method there, then return to this tab.
        </b-notification>
      </div>

      <div class="pt-5">
        <label class="label"
          >Payment Method<Info
            title="Name"
            information="Select the stored payment that you want to use to schedule this payment."
        /></label>
        <valid-select
          placeholder="Payment Method"
          vid="paymentMethodID"
          v-model="ownerPaymentMethodID"
          aria-required="The payment method is required"
          rules="required"
        >
          <option v-for="option in paymentMethods" :value="option.value" :key="option.value">{{
            option.label
          }}</option>
        </valid-select>
      </div>
      <div>&nbsp;</div>
      <div v-if="chargeTypeList !== undefined && chargeTypeList.length > 0">
        <div>
          <b-notification type="is-info is-light" has-icon aria-close-label="Close notification">
            You may select additional amounts to include in your automatic payment every month that
            apply to other outstanding charges as listed below. The amount added to your payment
            will be no more than the amount owed at the time. For example, if you specify $100.00
            and only $50.00 is owed at the time of the automatic payment, then only $50.00 will be
            added your payment.
          </b-notification>
        </div>
        <div class="pt-5">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <transition name="fade" mode="out-in" appear>
              <form @submit.prevent="handleSubmit(onFormSubmit)" class="form">
                <template v-for="(row, index) in chargeTypeList">
                  <div class="columns" :key="index">
                    <div class="column is-4">
                      <b-field :label="index === 0 ? 'Charge Type Name' : ''">
                        {{ row.name || '' }}
                      </b-field>
                    </div>
                    <div class="column is-4">
                      <label v-if="index === 0" class="label">Pay Amount</label>
                      <b-input
                        :name="`Amount${row.chargeTypeId}`"
                        type="text"
                        :vid="`Amount${row.chargeTypeId}`"
                        placeholder="0.00"
                        aria-label="PayAmount"
                        class="is-small"
                        :value="
                          formatter.format(
                            row.additionalScheduledAmount != undefined &&
                              row.additionalScheduledAmount
                              ? row.AdditionalScheduledAmount
                              : 0
                          )
                        "
                        v-model="form.amount[index]"
                        onkeypress="return (event.charCode >= 48 || event.charCode == 46) && event.charCode <= 57"
                        v-cleave="masks.numeral"
                      />
                      <input type="hidden" v-model="form.amountId[index]" />
                    </div>
                  </div>
                </template>
                <fieldset>
                  <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                    <div class="field">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </fieldset>
              </form>
            </transition>
          </ValidationObserver>
        </div>
      </div>
      <div class="pt-5" v-if="scheduledOwnerPaymentMethodID">
        <button
          @click.prevent="schedulePayment(false)"
          class="button is-primary is-rounded"
          :disabled="loading"
        >
          Update Scheduled Payment</button
        ><span class="pl-3"></span>
        <button
          @click.prevent="confirmRemoveScheduledPayment"
          class="button is-primary is-rounded"
          :disabled="loading"
        >
          Remove Scheduled Payment
        </button>
      </div>
      <div class="pt-5" v-else>
        <button
          @click.prevent="schedulePayment(false)"
          class="button is-primary is-rounded"
          :disabled="loading"
        >
          Schedule Payment
        </button>
      </div>
    </div>
    <div v-else>
      <b-notification type="is-info is-light" closable="false">
        Payment functionality is currently not available. We expect to enable this functionality
        soon, and will notify you via email when payments are available.
      </b-notification>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { methods } from './keys/methods'
import { data } from './keys/data'
import ValidSelect from '@/components/inputs/ValidSelect'
import Info from '@/components/icons/Info'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Cleave from 'cleave.js'

const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input')
    input._vCleave = new Cleave(input, binding.value)
  },
  unbind(el) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
  }
}

export default {
  directives: { cleave },
  name: 'OwnerPaymentMethod',
  components: {
    PageContentLayoutOnly,
    ValidSelect,
    Info,
    ValidationObserver,
    ValidationProvider
  },

  data,

  methods,

  computed: {
    ...mapState({
      unit: state => state.hoa.unit,
      ...mapGetters('user', ['authUser', 'retrieveUser', 'currentHoaId', 'currentOwnerId'])
    }),

    dollarCurrency(total) {
      return this.formatter.format(total)
    }
  },

  mounted() {
    this.reload()
  },

  i18n: {
    messages: {
      en: { scheduledPayment: { title: 'Automatic Payments' } }
    }
  }
}
</script>

<style></style>
